import React, { useState, useEffect } from "react";
import { Card } from "./SprzedazComponentStyle";
import { FaFileExcel } from "react-icons/fa";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFilePdf } from "react-icons/fa6";

// NOTE: onExportToExcel comes from parent (SpzedazData)
const SprzedazFilter = ({
  allData,
  filteredData,
  onDataFiltered,
  onExportToExcel,
}) => {
  const [filters, setFilters] = useState({
    NrKontrahenta: "",
    NazwaKontrahenta: "",
    Rok: "",
    Quarter: "",
    Miesiac: "",
    startDate: "",
    endDate: "",
    TP: false,
    EU: false,
    DOMESTIC: false,
    OTHER: false,
    Service: false,
  });

  const resetFilters = () => {
    setFilters({
      NrKontrahenta: "",
      NazwaKontrahenta: "",
      Rok: "",
      Quarter: "",
      Miesiac: "",
      startDate: "",
      endDate: "",
      TP: false,
      EU: false,
      DOMESTIC: false,
      OTHER: false,
      Service: false,
    });
  };

  const quarters = ["Q1", "Q2", "Q3", "Q4"];
  const months = [
    { name: "Styczeń", value: 1 },
    { name: "Luty", value: 2 },
    { name: "Marzec", value: 3 },
    { name: "Kwiecień", value: 4 },
    { name: "Maj", value: 5 },
    { name: "Czerwiec", value: 6 },
    { name: "Lipiec", value: 7 },
    { name: "Sierpień", value: 8 },
    { name: "Wrzesień", value: 9 },
    { name: "Październik", value: 10 },
    { name: "Listopad", value: 11 },
    { name: "Grudzień", value: 12 },
  ];

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  const applyFilters = () => {
    const filtered = allData.filter((item) => {
      const matchesYear = !filters.Rok || item.Rok === parseInt(filters.Rok);
      const matchesQuarter =
        !filters.Quarter ||
        (item.Miesiac &&
          Math.floor((item.Miesiac - 1) / 3) + 1 ===
            parseInt(filters.Quarter.replace("Q", "")));
      const matchesMonth =
        !filters.Miesiac || item.Miesiac === parseInt(filters.Miesiac);
      const matchesDateRange =
        (!filters.startDate ||
          new Date(item.DataSprzedazy) >= new Date(filters.startDate)) &&
        (!filters.endDate ||
          new Date(item.DataSprzedazy) <= new Date(filters.endDate));
      const matchesTP = !filters.TP || item["TP Transaction"] === "✓";

      const selectedRegions = [];
      if (filters.EU) selectedRegions.push("EU");
      if (filters.DOMESTIC) selectedRegions.push("Domestic");
      if (filters.OTHER) selectedRegions.push("Export / Import");

      const matchesRegion =
        selectedRegions.length === 0 ||
        selectedRegions.every((region) => item[region] === "✓");

      const matchesService = !filters.Service || item.Service === "✓";

      return (
        (filters.NrKontrahenta === "" ||
          (item.NrKontrahenta &&
            item.NrKontrahenta.includes(filters.NrKontrahenta))) &&
        (filters.NazwaKontrahenta === "" ||
          (item.NazwaKontrahenta &&
            item.NazwaKontrahenta.includes(filters.NazwaKontrahenta))) &&
        matchesYear &&
        matchesQuarter &&
        matchesMonth &&
        matchesDateRange &&
        matchesTP &&
        matchesRegion &&
        matchesService
      );
    });

    onDataFiltered(filtered);
  };

  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, allData]);

  // ---------- PDF EXPORT ----------


  const columnLabels = {
    KodFormularza: "Kod",
    Rok: "Rok",
    Miesiac: "Miesiac",
    LpSprzedazy: "LP",
    NazwaKontrahenta: "Kontrahent",
    KodKrajuNadaniaTIN: "Kraj",
    DowodSprzedazy: "Dowod Sprzedazy",
    DataWystawienia: "Data Wystawienia",
    Amount: "Kwota",
    "Vat Amount": "VAT",
    Domestic: "Krajowe",
    EU: "EU",
    "Export / Import": "Eksport/Import",
    "TP Transaction": "TP",
    Service: "Uslugi",
    // you can keep the extra labels (ZW, GTU_**, etc.) – they just won't be used in PDF
  };

  const hiddenColumns = [
    "id",
    "Hide",
    "kodSystemowy",
    "wersjaSchemy",
    "WariantFormularza",
    "DataWytworzeniaJPK",
    "NazwaSystemu",
    "CelZlozenia",
    "poz",
    "KodUrzedu",
    "rola",
    "Email",
    "DataSprzedazy",
    "TP",
    // "GTU_05", // keep visible
    "PelnaNazwa",
    "NIP",
  ];

  const getUserEmail = () => {
    const emailRe = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
    const preferred = ["user", "profile", "auth", "account", "email", "Email"];
    const pick = (raw) => {
      if (!raw) return "";
      try {
        const o = JSON.parse(raw);
        const guess =
          o?.Email ||
          o?.email ||
          o?.user?.Email ||
          o?.user?.email ||
          o?.profile?.Email ||
          o?.profile?.email ||
          o?.account?.Email ||
          o?.account?.email ||
          "";
        if (emailRe.test(String(guess))) return String(guess).trim();
        for (const k of Object.keys(o)) {
          const v = o[k];
          if (typeof v === "string" && emailRe.test(v)) return v.match(emailRe)[0];
          if (v && typeof v === "object") {
            for (const kk of Object.keys(v)) {
              const vv = v[kk];
              if (typeof vv === "string" && emailRe.test(vv)) return vv.match(emailRe)[0];
            }
          }
        }
      } catch {
        const m = raw.match(emailRe);
        if (m) return m[0];
      }
      return "";
    };
    for (const k of preferred) {
      const em = pick(localStorage.getItem(k));
      if (em) return em;
    }
    for (let i = 0; i < localStorage.length; i++) {
      const em = pick(localStorage.getItem(localStorage.key(i)));
      if (em) return em;
    }
    return "-";
  };

  const getLocalStamp = () =>
    new Date().toLocaleString("pl-PL", {
      timeZone: "Europe/Warsaw",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

  const formatForPdf = (key, val) => {
    if (["Amount", "Vat Amount"].includes(key)) {
      const n = parseFloat(
        String(val || "").replace(/[^\d.-]/g, "").replace(",", ".")
      );
      if (Number.isNaN(n)) return "-";
      return n.toLocaleString("pl-PL");
    }
    if (["NIP", "NrKontrahenta"].includes(key)) {
      return val ? String(val).split(".")[0] : "-";
    }
    return val ?? "-";
  };

const handleExportToPDF = () => {
  try {
    if (!filteredData?.length) {
      alert("Brak danych do eksportu.");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const left = 12,
      right = 12,
      top = 16,
      bottom = 14;
    const pageWidth = doc.internal.pageSize.getWidth();

    const email = getUserEmail();
    const dateStr = getLocalStamp();

    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.setTextColor(30, 30, 30);
    doc.text("Sprzedaz Dane", left, top);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(70, 70, 70);
    doc.text(email, pageWidth - right, top, { align: "right" });
    doc.text(dateStr, pageWidth - right, top + 5, { align: "right" });

    doc.setFontSize(9);
    doc.setTextColor(90, 90, 90);
    doc.text(`Rekordy: ${filteredData.length}`, left, top + 12);

    doc.setDrawColor(210);
    doc.setLineWidth(0.3);
    doc.line(left, top + 15, pageWidth - right, top + 15);

    const pdfColumns = [
      "KodFormularza",
      "Rok",
      "Miesiac",
      "LpSprzedazy",
      "KodKrajuNadaniaTIN",
      "NrKontrahenta",
      "NazwaKontrahenta",
      "DowodSprzedazy",
      "DataWystawienia",
      "Amount",
      "Vat Amount",
      "Domestic",
      "EU",
      "Export / Import",
      "TP Transaction",
      "Service",
    ];

    const head = [pdfColumns.map((c) => columnLabels[c] || c)];
    const body = filteredData.map((row) =>
      pdfColumns.map((c) => formatForPdf(c, row[c]))
    );

    const iconKeys = [
      "Domestic",
      "EU",
      "Export / Import",
      "TP Transaction",
      "Service",
    ];

    const colStyles = {};
    pdfColumns.forEach((c, idx) => {
      colStyles[idx] = ["Amount", "Vat Amount"].includes(c)
        ? { halign: "right" }
        : { halign: "center" };
    });

    autoTable(doc, {
      startY: top + 18,
      head,
      body,
      styles: {
        font: "helvetica",
        fontSize: 8,
        cellPadding: 2,
        lineColor: [220, 220, 220],
        lineWidth: 0.2,
        overflow: "linebreak",
        valign: "middle",
      },
      headStyles: {
        fillColor: [135, 206, 235],
        textColor: 255,
        fontStyle: "bold",
      },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: colStyles,
      margin: { left, right, top: top + 4, bottom },

      didParseCell: (data) => {
        if (data.section !== "body") return;
        const keyAtCol = pdfColumns[data.column.index];
        if (iconKeys.includes(keyAtCol)) {
          data.cell.text = [""];
        }
      },

      didDrawCell: (data) => {
        if (data.section !== "body") return;

        const rowIdx = data.row.index;
        const colIdx = data.column.index;
        const keyAtCol = pdfColumns[colIdx];
        if (!iconKeys.includes(keyAtCol)) return;

        const raw = (filteredData[rowIdx] || {})[keyAtCol];
        if (raw !== "✓" && raw !== "✗") return;

        const { cell } = data;
        const cx = cell.x + cell.width / 2;
        const cy = cell.y + cell.height / 2;

        // FIXED radius so dots always visible and same size
        const r = 1.4; // mm – tweak if you want bigger/smaller

        if (raw === "✓") doc.setFillColor(46, 125, 50);
        else doc.setFillColor(211, 47, 47);

        if (doc.circle) doc.circle(cx, cy, r, "F");
        else doc.rect(cx - r, cy - r, 2 * r, 2 * r, "F");
      },

      didDrawPage: () => {
        const page = doc.internal.getNumberOfPages();
        const pageStr = `Strona ${page}`;
        doc.setFontSize(9);
        doc.setTextColor(100);
        const y = doc.internal.pageSize.getHeight() - 6;
        doc.text(pageStr, left, y);
      },
    });

    doc.save(`Sprzedaz_Dane_${new Date().toISOString().slice(0, 10)}.pdf`);
  } catch (e) {
    console.error("PDF export error:", e);
    alert("Wystąpił błąd podczas generowania PDF.");
  }
};


  // ---------- UI (unchanged) ----------
  return (
    <Card>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          flexWrap: "wrap",
          marginBottom: "20px",
        }}
      >
        {/* Row 1 */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          <div
            style={{ display: "flex", flexDirection: "column", minWidth: "200px" }}
          >
            <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
              Nr Kontrahenta:
            </label>
            <input
              type="text"
              value={filters.NrKontrahenta}
              onChange={(e) =>
                handleFilterChange("NrKontrahenta", e.target.value)
              }
              style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", minWidth: "200px" }}
          >
            <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
              Nazwa Kontrahenta:
            </label>
            <input
              type="text"
              value={filters.NazwaKontrahenta}
              onChange={(e) =>
                handleFilterChange("NazwaKontrahenta", e.target.value)
              }
              style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            {["TP", "EU", "DOMESTIC", "OTHER", "Service"].map((key) => (
              <label
                key={key}
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  type="checkbox"
                  checked={filters[key]}
                  onChange={(e) =>
                    handleFilterChange(key, e.target.checked)
                  }
                  style={{ marginRight: "6px" }}
                />
                {key}
              </label>
            ))}
          </div>
        </div>

        {/* Row 2 */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          <div
            style={{ display: "flex", flexDirection: "column", minWidth: "120px" }}
          >
            <label style={{ fontWeight: "bold", marginBottom: "5px" }}>Rok:</label>
            <input
              type="number"
              min="2000"
              max={new Date().getFullYear()}
              value={filters.Rok}
              onChange={(e) => handleFilterChange("Rok", e.target.value)}
              style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", minWidth: "140px" }}
          >
            <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
              Kwartal:
            </label>
            <select
              value={filters.Quarter}
              onChange={(e) => handleFilterChange("Quarter", e.target.value)}
              style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            >
              <option value="">Wszystkie</option>
              {quarters.map((q) => (
                <option key={q} value={q}>
                  {q}
                </option>
              ))}
            </select>
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", minWidth: "160px" }}
          >
            <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
              Miesiąc:
            </label>
            <select
              value={filters.Miesiac}
              onChange={(e) => handleFilterChange("Miesiac", e.target.value)}
              style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            >
              <option value="">Wszystkie</option>
              {months.map(({ name, value }) => (
                <option key={value} value={value}>
                  {name}
                </option>
              ))}
            </select>
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", minWidth: "160px" }}
          >
            <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
              Data początkowa:
            </label>
            <input
              type="date"
              value={filters.startDate}
              onChange={(e) =>
                handleFilterChange("startDate", e.target.value)
              }
              style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", minWidth: "160px" }}
          >
            <label style={{ fontWeight: "bold", marginBottom: "5px" }}>
              Data końcowa:
            </label>
            <input
              type="date"
              value={filters.endDate}
              onChange={(e) =>
                handleFilterChange("endDate", e.target.value)
              }
              style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
          </div>

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <button
              type="button"
              onClick={onExportToExcel}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "6px 14px",
                backgroundColor: "#217346",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "14px",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#1a5d36")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#217346")
              }
            >
              <FaFileExcel style={{ fontSize: "16px" }} />
              Eksportuj do Excela
            </button>

            <button
              type="button"
              onClick={handleExportToPDF}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "6px 14px",
                backgroundColor: "#87CEEB",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "14px",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#62b2d6")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#87CEEB")
              }
            >
              <FaFilePdf style={{ fontSize: "16px" }} />
              Eksportuj do PDF
            </button>

            <button
              type="button"
              onClick={resetFilters}
              style={{
                padding: "6px 14px",
                backgroundColor: "#d9534f",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "14px",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#c9302c")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#d9534f")
              }
            >
              Resetuj Filtry
            </button>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SprzedazFilter;
